import { useContext } from 'react';
import { InstantSearchRSCContext } from "./InstantSearchRSCContext.js";
export function useRSCContext() {
  return useContext(InstantSearchRSCContext);
}